export default "__VITE_ASSET__DwC0pKGx__"